import React, { Component } from 'react'
import { connect } from 'react-redux'
import { setHeader } from '../actions'
import HomeCalendar from '../components/HomeCalendar'
import HomePlans from '../components/HomePlans'
import HomeNotification from '../components/HomeNotification'

class Home extends Component {
  componentWillMount() {
    this.props.setHeader({
      title: "NS Board",
      left: null,
      right: null
    })
  }
  render() {
    return (
      <div className="home content">
        <HomeNotification />
        <HomePlans />
        <h2>予約カレンダー</h2>
        <HomeCalendar />
      </div>
    )
  }
}

export default connect(
  state => ({}),
  { setHeader }
)(Home)


// WEBPACK FOOTER //
// ./src/containers/Home.js